module.exports = __webpack_public_path__ + "media/images/logo-6555813ce76a33efdc6a36679cb5d411.svg";